let createPostSignupProductor = ({
  fetch,
  environment,
  buildRequestWithAuth,
  errorUnlessOk
}) => formData => {
  let request = buildRequestWithAuth("POST", formData);

  return fetch(
    `${environment.authUrl}/controldeusuarios/registroproductor`,
    request
  )
    .then(errorUnlessOk)
    .then(response => {
      return response.json();
    })
    .catch(error => {
      console.error(error);
      throw error;
    });
};

export { createPostSignupProductor };
